import type { RunStatus } from "../../api/types/onboardingRun";

// Statuses where the runner is (or is about to be) active, so RunDetail polls.
// queued is included so the first runner transition (queued → claimed) isn't stale.
const POLL_STATES = new Set<RunStatus>(["queued", "claimed", "running"]);

export const RUN_POLL_MS = 4000;

/** refetchInterval value for a run's status: poll interval, or false to stop. */
export function runPollInterval(status: RunStatus | undefined): number | false {
  return status && POLL_STATES.has(status) ? RUN_POLL_MS : false;
}
